// Utility for money conversions

/**
 * Converts a dollar amount (string or number) to integer cents.
 * E.g. '99.00' => 9900
 */
export function dollarsToCents(amount: string | number): number {
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;
  return Math.round(num * 100);
}

/**
 * Converts integer cents to a dollar string with 2 decimals.
 * E.g. 9900 => '99.00'
 */
export function centsToDollars(cents: number): string {
  return (cents / 100).toFixed(2);
} 